import { render, staticRenderFns } from "./StandardDialog.vue?vue&type=template&id=49e8b66c&scoped=true&lang=html&"
import script from "./StandardDialog.vue?vue&type=script&lang=js&"
export * from "./StandardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8b66c",
  null
  
)

export default component.exports